// src/components/profile/ProfileSection.jsx

import React from 'react';
import { Paper, Typography, Box } from '@material-ui/core';
import { useProfileStyles } from './profileStyles';

const ProfileSection = ({
  title,
  icon: Icon,
  children,
}) => {
  const classes = useProfileStyles();

  return (
    <Paper className={classes.section}>
      <Box className={classes.sectionHeader}>
        {Icon && (
          <Box className={classes.sectionIcon}>
            <Icon fontSize="small" />
          </Box>
        )}

        <Typography variant="h6" className={classes.sectionTitle}>
          {title}
        </Typography>
      </Box>

      {children}
    </Paper>
  );
};

export default ProfileSection;